import { Component, OnInit } from '@angular/core';
import { PagerService } from '../_services/pager.service'

@Component({
  selector: 'app-hotnews',
  template: require('./hotnews.component.html'),
  styles: [require('./hotnews.component.css')]
})
export class HotNewsComponent implements OnInit {
  private allItems= [
    {
        "id":1,
        "name": "Item 1"
    },
    {
        "id":2,
        "name": "Item 2"
    },
    {
        "id":3,
        "name": "Item 3"
    },
    {
        "id":4,
        "name": "Item 4"
    },
    {
        "id":5,
        "name": "Item 5"
    },
    {
        "id":6,
        "name": "Item 6"
    },
    {
        "id":7,
        "name": "Item 7"
    },
    {
        "id":8,
        "name": "Item 8"
    },
    {
        "id":9,
        "name": "Item 9"
    },
    {
        "id":10,
        "name": "Item 10"
    }];

  // pager object
  pager: any = {};

  // paged items
  pagedItems : any [];

  constructor(private pagerService: PagerService) { }
  
  ngOnInit() {
    this.setPage(1);
    console.log(this.pagedItems)
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
        return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page);

    // get current page of items
    this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
}

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/news/hotnews/hotnews.component.ts